export default "__VITE_ASSET__995bbb5c__"